import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0b1a09f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "game-notification-item" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]

import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  props: {
  id: {
    type: Number,
    required: true,
  },
  icon: {
    type: String
  },
  title: {
    type: String
  },
  description: {
    type: String
  },
  points: {
    type: Number,
    default: 0
  },
},
  setup(__props) {

const props = __props



const iconClass = computed(() => {
  const classes = ['icon']
  if (props.points < 0 ) {
    classes.push('icon--fail')
  }
  if (props.points > 0 ) {
    classes.push('icon--success')
  }
  return classes
})

return (_ctx: any,_cache: any) => {
  const _component_ui_icon = _resolveComponent("ui-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.icon)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(_unref(iconClass)),
          "data-transition-enter": ""
        }, [
          _createVNode(_component_ui_icon, { name: __props.icon }, null, 8, ["name"])
        ], 2))
      : _createCommentVNode("", true),
    (__props.title)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "title",
          "data-transition-enter": "",
          innerHTML: __props.title
        }, null, 8, _hoisted_2))
      : _createCommentVNode("", true),
    (__props.description)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: "description",
          "data-transition-enter": "",
          innerHTML: __props.description
        }, null, 8, _hoisted_3))
      : _createCommentVNode("", true)
  ]))
}
}

})